<div class="grid-row " (click)="edit()" [ngClass]="{'bottom':isLast}">
    <div class="list-item flex-3 warp-ellipsis xxx">
        <p class="ellipsis-p">{{listCollectionItem?.name}}</p>
    </div>
    <div class="tooltip-abs" *ngIf="listCollectionItem?.name">
        <p>{{listCollectionItem?.name}}</p>
    </div>
    <div class="list-item flex-2">{{listCollectionItem?.createDate | queDate}}</div>
    <div class="list-item flex-2">
        <div class="circle">
            <p> {{ listCollectionItem?.creator?.firstName ?
                listCollectionItem?.creator?.firstName?.charAt(0)?.toUpperCase() :
                ''}}</p>
            <p>{{ listCollectionItem?.creator?.lastName ?
                listCollectionItem?.creator?.lastName?.charAt(0)?.toUpperCase() : '' }}
            </p>
        </div>
        {{listCollectionItem?.creator?.firstName}} {{listCollectionItem?.creator?.lastName}}
    </div>

    <div class="list-item flex-half last">
        <div #trigger (click)="openMenu($event)">
            <img src="/assets/images/grid/menuPoint.svg">
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayHasBackdrop]="true"
            [cdkConnectedOverlayOpen]="true" cdkConnectedOverlayBackdropClass="backdrop-selection"
            (backdropClick)="isMenuOpen=false" [cdkConnectedOverlayOpen]="isMenuOpen"
            [cdkConnectedOverlayPositions]="positonArea">
            <div class="overlay-warp">
                <div class="item" (click)="edit()">
                    <img src="/assets/images/grid/menu/edit.svg">
                    <p translate>grid.menu.edit</p>
                </div>
                <div class="item" (click)="changeStatus()">
                    <que-toggle [toggleState]="!isDisplayNotActiveItems$()"></que-toggle>
                    <p *ngIf="!isDisplayNotActiveItems$()" translate>grid.menu.changeStatusToNotActive</p>
                    <p *ngIf="isDisplayNotActiveItems$()" translate>grid.menu.changeStatusToActive</p>
                </div>
                <div class="item" (click)="duplicate()">
                    <img src="/assets/images/grid/menu/duplicate.svg">
                    <p translate>grid.menu.duplicate</p>
                </div>
            </div>
        </ng-template>
    </div>
</div>